<div class="mat-typography">
  <app-loader [showText]="true"></app-loader>
</div>
